const isValidKey = (key: string | number | symbol, object: object): key is keyof typeof object => key in object
export default isValidKey
